import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Channel codes match the short_name in payment_channel table
export type ChannelCode = 'web' | 'vt' | 'crm' | 'mobile' | 'fms';

// Maps channel codes to payment_channel_id from database
export const CHANNEL_CODE_TO_ID: Record<ChannelCode, number> = {
  web: 1,      // FinWeb
  vt: 2,       // FinTerminal (virtual terminal)
  crm: 3,      // FinCRM
  mobile: 4,   // FinMobile
  fms: 5,      // FinPay Managed Service
};

interface PaymentContextState {
  channelId: number | null;
}

const initialState: PaymentContextState = {
  channelId: null,
};

const paymentContextSlice = createSlice({
  name: 'paymentContext',
  initialState,
  reducers: {
    setChannelId: (state, action: PayloadAction<number>) => {
      state.channelId = action.payload;
    },
    setChannelFromCode: (state, action: PayloadAction<ChannelCode>) => {
      state.channelId = CHANNEL_CODE_TO_ID[action.payload] ?? 5;
    },
    clearPaymentContext: (state) => {
      state.channelId = null;
    },
  },
});

export const { setChannelId, setChannelFromCode, clearPaymentContext } = paymentContextSlice.actions;
export default paymentContextSlice.reducer;
